module.exports = __webpack_public_path__ + "static/img/level_on.b94badf0.png";